import { ControlStateOptions } from "./ControlStateOptions"

/**
 *  Determine the CSS class for the padding of a control element based
 *  on the passed state options.
 */
export function determineControlPaddingClass(state: ControlStateOptions) {
  // readonly controls don't have a padding at all.
  if (state.readOnly) {
    return "p-0"
  }

  return "py-1.5 px-3"
}
